import { StoplightProject } from "@stoplight/elements-dev-portal";
import "@stoplight/elements-dev-portal/styles.min.css";
import "./Registrativos.css"

function Registrativos() {
  return (
    <div className="container">
      <StoplightProject projectId="cHJqOjI2NTI1OQ" router="hash" />
    </div>
  );
}

export default Registrativos;
